export function waitUntil(condition: () => boolean, timeout = 1000): Promise<void> {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (condition()) {
        clearInterval(interval)
        resolve()
      }
    }, timeout)
  })
}
